import { useCallback } from 'react';

//@ts-ignore
import { default as useAuthLogout } from 'ui_auth/useLogout';

function useLogout() {
  const logout = useAuthLogout();

  // Kept this function, if we later want to introduce any cleanups
  const logoutWithCleanup = useCallback(async () => {
    await logout();
  }, [logout]);

  return logoutWithCleanup;
}

export default useLogout;
